import { TFunction } from "i18next";

const config = {
  lng: "en"
};

export const customerFacingPublishingMode = (
  publishingMode: string,
  t: TFunction,
  fallbackLanguage = true
) => {
  const options = fallbackLanguage ? config : {};
  switch (publishingMode) {
    case "Manual":
      return t("programBuilder.publishingmethod.manual", options);
    case "MachineAutoPublish":
      return t("programBuilder.publishingmethod.machine", options);
    case "PremiumAutoPublish":
      return t("programBuilder.publishingmethod.premium", options);
    case "SellerPaid":
      return t("programBuilder.publishingmethod.seller", options);
    default:
      return publishingMode;
  }
};
